import { useBucket } from '@mc/experiments-react'
import {
  type CmLayout,
  useMCProPromoCmLayout,
} from 'experiments/prcng-1270_v1_mc_pro_promo'
import { EXPERIMENT_FLAG } from '../constants'

const CM_LAYOUT_BY_BUCKET: Partial<Record<string, CmLayout>> = {
  variant_1: 'dual_cta',
  variant_2: 'pro_section',
  variant_3: 'pro_section',
}

export const useCmLayout = (): CmLayout | undefined => {
  const bucket = useBucket(EXPERIMENT_FLAG)
  const mcProPromoCmLayout = useMCProPromoCmLayout()
  const cmDualCtaLayout = bucket ? CM_LAYOUT_BY_BUCKET[bucket] : undefined

  return cmDualCtaLayout ?? mcProPromoCmLayout
}
